import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PersonalityRole } from "../../../../../../types/domain-types";

export function useTranslatedPersonalityRoles() {
  const { t } = useTranslation();

  return useMemo(() => {
    return {
      [PersonalityRole.Mediator]: {
        name: t("frontend.test.reflectionResults.mediator.name", "Mediator"),
        description: t(
          "frontend.test.reflectionResults.mediator.description",
          "Mediator description"
        ),
      },
      [PersonalityRole.Advisor]: {
        name: t("frontend.test.reflectionResults.advisor.name", "Advisor"),
        description: t(
          "frontend.test.reflectionResults.advisor.description",
          "Advisor description"
        ),
      },
      [PersonalityRole.Innovator]: {
        name: t("frontend.test.reflectionResults.innovator.name", "Innovator"),
        description: t(
          "frontend.test.reflectionResults.innovator.description",
          "Innovator description"
        ),
      },
      [PersonalityRole.Controller]: {
        name: t(
          "frontend.test.reflectionResults.controller.name",
          "Controller"
        ),
        description: t(
          "frontend.test.reflectionResults.controller.description",
          "Controller description"
        ),
      },
      [PersonalityRole.Director]: {
        name: t("frontend.test.reflectionResults.director.name", "Director"),
        description: t(
          "frontend.test.reflectionResults.director.description",
          "Director description"
        ),
      },
      [PersonalityRole.Motivator]: {
        name: t("frontend.test.reflectionResults.motivator.name", "Motivator"),
        description: t(
          "frontend.test.reflectionResults.motivator.description",
          "Motivator description"
        ),
      },
      [PersonalityRole.Brakeman]: {
        name: t("frontend.test.reflectionResults.brakeman.name", "Brakeman"),
        description: t(
          "frontend.test.reflectionResults.brakeman.description",
          "Brakeman description"
        ),
      },
      [PersonalityRole.Critic]: {
        name: t("frontend.test.reflectionResults.critic.name", "Critic"),
        description: t(
          "frontend.test.reflectionResults.critic.description",
          "Critic description"
        ),
      },
      [PersonalityRole.Driver]: {
        name: t("frontend.test.reflectionResults.driver.name", "Driver"),
        description: t(
          "frontend.test.reflectionResults.driver.description",
          "Driver description"
        ),
      },
    };
  }, [t]);
}
